module.exports = __webpack_public_path__ + "static/img/Platinum4.33c1058.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/apex/Platinum4.svg
// module id = wOf8
// module chunks = 35